/**
 * The composer's height-determining box.
 *
 * This module imports nothing, on purpose. `LaunchComposerSkeleton` is what
 * SSR paints on BOTH `/` and `/home` — each gates the real composer behind an
 * async client effect — so it has to learn how tall the editable is without
 * dragging `@tigerabrodioss/fude`, `SmartTextbox` or `TextShimmer` into the
 * first-paint chunk. For the same reason this is not re-exported from
 * `prompt-input/index.tsx`: that barrel would hand the heavy graph back.
 *
 * `launch-composer-chrome.ts` already owns the frame and the card for exactly
 * this reason. This is the piece that escaped it: the editable moved to
 * `min-h-24`, the hand-mirrored skeleton stayed at `min-h-16`, and the hero
 * was 32px short on every load of both pages until 2026-09.
 *
 * The paddings and leading ride along with the floor so the first line of
 * placeholder text lands in the same place across the swap, not just the box.
 */
export const PROMPT_INPUT_TEXTAREA_BOX_CLASSNAME =
  'min-h-24 w-full px-5 pt-4 pb-3 text-sm leading-6'
